import { createTheme } from '@mui/material/styles'
import { colors } from './colors'

const getTheme = theme => {
  const newTheme = theme?.theme ? theme?.theme : null
  return createTheme({
    palette: {
      primary: {
        main: newTheme?.navigation_color || colors.amber,
        contrastText: colors.white,
      },
      secondary: {
        main: newTheme?.button_color || colors.amber,
        contrastText: colors.white,
      },
      title: {
        main: newTheme?.navigation_color || colors.amber,
        contrastText: colors.white,
      },
      section_title: {
        main: colors.darkgray,
        contrastText: colors.white,
      },
      box_title: {
        main: colors.white,
        contrastText: colors.white,
      },
      button_color: {
        main: colors.darkamber,
        contrastText: colors.white,
      },
      button_white: {
        main: colors.white,
        contrastText: colors.white,
      },
      green: {
        main: colors.green,
        sad: colors.sadgreen,
        contrastText: colors.white,
      },
      blue: {
        main: colors.blue,
        dark: colors.darkblue,
        sad: colors.sadblue,
        contrastText: colors.white,
      },
      warning: {
        main: colors.warning,
        contrastText: colors.white,
      },
      danger: {
        main: colors.red,
        contrastText: colors.white,
      },
      white: {
        main: colors.white,
        contrastText: colors.darkamber,
      },

    },
    icons: {
      main: newTheme?.navigation_color || colors.black,
      contrastText: colors.white,
    },
    icons_lite: {
      main: colors.midgray,
      contrastText: colors.white,
    },
    fonts: {
      primary: 'Lato',
    },
    logo: {
      url: newTheme?.logo ? newTheme?.logo : null,
    },
    typography: {
      useNextVariants: true,
      fontFamily: ['Lato', 'sans-serif'].join(','),
      fontSize: 16,
      variants: {
        title: {
          fontSize: 24,
          fontWeight: 700,
        },
        subtitle: {
          fontSize: 18,
          fontWeight: 600,
        },
        body: {
          fontSize: 16,
          fontWeight: 400,
        },
      },
    },
    overrides: {
      MuiButton: {
        root: {
          minHeight: 48,
          fontWeight: 'bold',
          fontSize: 14,
          textTransform: 'capitalize',
        },
      },
      MuiTypography: {
        h2: {
          fontSize: 24,
          fontWeight: 700,
        },
      },
      MuiFilledInput: {
        root: {
          backgroundColor: 'transparent',
          border: `solid 1px ${colors.gray}`,
          borderRadius: 8,
          '&&.Mui-error': {
            borderColor: 'red',
          },
          '&&:before, &&:after ': {
            display: 'none',
          },
        },
      },
    },
  })
}

export { getTheme }
